import { useState, useCallback, useRef, useEffect } from "react";

interface UsePanelResizeOptions {
  initialWidth: number;
  minWidth: number;
  maxWidth: number;
}

export function usePanelResize({ initialWidth, minWidth, maxWidth }: UsePanelResizeOptions) {
  const [panelWidth, setPanelWidth] = useState(initialWidth);
  const dragging = useRef<{ startX: number; startWidth: number } | null>(null);

  const onDividerPointerDown = useCallback(
    (e: React.PointerEvent) => {
      e.preventDefault();
      e.stopPropagation();
      dragging.current = { startX: e.clientX, startWidth: panelWidth };
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },
    [panelWidth]
  );

  useEffect(() => {
    const onPointerMove = (e: PointerEvent) => {
      const d = dragging.current;
      if (!d) return;
      const dx = e.clientX - d.startX;
      const newWidth = Math.max(minWidth, Math.min(maxWidth, d.startWidth + dx));
      setPanelWidth(newWidth);
    };

    const onPointerUp = () => {
      if (dragging.current) {
        dragging.current = null;
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      }
    };

    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);
    return () => {
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", onPointerUp);
    };
  }, [minWidth, maxWidth]);

  return { panelWidth, onDividerPointerDown };
}
